import React, { useMemo } from 'react';
import useIntl from '@i18n/useIntl';
import DropdownController from '@components/form/DropdownController';
import * as formConstants from '@components/form/constants';
import * as accountInfoConstants from '@features/account-settings/constants';
import { ControllersWrapper } from '@components/form/style';
import { useGetEnumerationsQuery } from '@services/account/account';
import { ControllerConfigurations } from '@features/account-settings/types';

interface AccountAttributesControllersProps {
  configuration?: ControllerConfigurations;
  managerAccountId?: string | null;
}

const AccountAttributesControllers = ({
  configuration,
  managerAccountId,
}: AccountAttributesControllersProps) => {
  const { intl } = useIntl();
  const {
    data: enumerations,
    isLoading,
    isError,
  } = useGetEnumerationsQuery({ managerAccountId });
  const requiredValidation = useMemo(
    () => ({
      required: intl.getMessage(
        formConstants.REQUIRED_VALIDATION_ERROR_MESSAGE_TRANSLATION_KEY,
      ),
    }),
    [intl],
  );
  return (
    <ControllersWrapper>
      <DropdownController
        label={intl.getMessage(
          accountInfoConstants.ACCOUNT_CURRENCY_FIELD_LABEL,
        )}
        id={accountInfoConstants.ACCOUNT_CURRENCY_FIELD_ID}
        controllerName={
          accountInfoConstants.ACCOUNT_CURRENCY_FIELD_CONTROLLER_NAME
        }
        items={enumerations?.currencies || []}
        isLoading={isLoading}
        disabled={
          isError ||
          configuration?.[
            accountInfoConstants?.ACCOUNT_CURRENCY_FIELD_CONTROLLER_NAME
          ]?.disabled
        }
        registerOptions={{
          ...requiredValidation,
        }}
        overrideDropdownLabel={`${intl.getMessage(
          accountInfoConstants.REGISTRATION_DROPDOWN_DEFAULT_LABEL_PREFIX,
        )} 
     ${intl
       .getMessage(accountInfoConstants.ACCOUNT_CURRENCY_FIELD_LABEL)
       .toLocaleLowerCase()}
      `}
      />
      <DropdownController
        label={intl.getMessage(
          accountInfoConstants.ACCOUNT_TIME_ZONE_FIELD_LABEL,
        )}
        id={accountInfoConstants.ACCOUNT_TIME_ZONE_FIELD_ID}
        controllerName={
          accountInfoConstants.ACCOUNT_TIME_ZONE_FIELD_CONTROLLER_NAME
        }
        items={enumerations?.timeZones || []}
        isLoading={isLoading}
        disabled={
          isError ||
          configuration?.[
            accountInfoConstants.ACCOUNT_TIME_ZONE_FIELD_CONTROLLER_NAME
          ]?.disabled
        }
        registerOptions={{
          ...requiredValidation,
        }}
        overrideDropdownLabel={`${intl.getMessage(
          accountInfoConstants.REGISTRATION_DROPDOWN_DEFAULT_LABEL_PREFIX,
        )} 
      ${intl
        .getMessage(accountInfoConstants.ACCOUNT_TIME_ZONE_FIELD_LABEL)
        .toLocaleLowerCase()}
      `}
      />
      <DropdownController
        label={intl.getMessage(
          accountInfoConstants.ACCOUNT_INDUSTRY_FIELD_LABEL,
        )}
        id={accountInfoConstants.ACCOUNT_INDUSTRY_FIELD_ID}
        controllerName={
          accountInfoConstants.ACCOUNT_INDUSTRY_FIELD_CONTROLLER_NAME
        }
        items={enumerations?.industries || []}
        isLoading={isLoading}
        disabled={isError}
        registerOptions={{
          ...requiredValidation,
        }}
        overrideDropdownLabel={`${intl.getMessage(
          accountInfoConstants.REGISTRATION_DROPDOWN_DEFAULT_LABEL_PREFIX,
        )} 
      ${intl
        .getMessage(accountInfoConstants.ACCOUNT_INDUSTRY_FIELD_LABEL)
        .toLocaleLowerCase()}
      `}
      />
    </ControllersWrapper>
  );
};

export default AccountAttributesControllers;
